/* /sound-meter — карточка «Доза шума за смену» (21.10.2026).
 *
 * Арифметика — public/js/noise-dose.js (NoiseDose); здесь только то, что
 * связывает её с живым замером и с калькулятором задач смены:
 *
 *   · энергия берётся из той же интеграции, из которой собрана плитка Leq
 *     (window.__SM.state().stats.a.leqSum / leqCount — среднее квадратов
 *     после A-взвешивания, умноженное на время), по секунде за тик. Второй
 *     интегратор рядом дал бы второе число Leq на одной странице;
 *   · калибровка уже внутри этой энергии (смещение SPL `d` у sound-meter.js),
 *     поэтому доза её не пересчитывает;
 *   · пик C телефону не измерить: полная шкала микрофона — это и есть
 *     смещение (≈120 дБ SPL), а пороги пиков — 135…140 дБ(C). Карточка
 *     показывает то, что микрофон видел, и говорит «не меньше предела», когда
 *     сработал индикатор перегрузки, а не выдумывает LCpeak.
 *
 * Хуки в sound-meter.js (ручной минифицированный исходник) — только вызовы
 * window.SMDose.*: allowedSeconds (время до нормы для подсказок), tick и
 * doseText (полоса дозы), reset (новый замер), eightHourText/eightLabel
 * (плитка 8 ч), pdfHtml и csv (отчёты). Если этот файл не приехал, шумомер
 * работает по-старому (NIOSH).
 */
(function () {
    'use strict';
    var SM = window.__SM || {}, D = SM.D || {}, T = SM.T || {}, ND = window.NoiseDose;
    if (!ND || !D.std) return;

    var SLUG = 'sound-meter';
    var $ = function (id) { return document.getElementById(id); };
    var card = $('smDoseCard');
    var stdSel = $('smStd'), shiftIn = $('smShift');
    var live = ND.createLive();
    var lastSum = 0, lastCount = 0;
    var recent = [];           // последние ~10 с: {e, t} — «текущий уровень» для остатка
    var tasks = [];
    var locale = window.__LOCALE || 'en';

    function std() { var v = stdSel && stdSel.value; return ND.STANDARDS[v] ? v : ND.defaultFor(locale); }
    function shiftHours() { var h = parseFloat(shiftIn && shiftIn.value); return h > 0 && h <= 24 ? h : 8; }
    function intl() { try { return window.__intlLocale ? window.__intlLocale() : undefined; } catch (_) { return undefined; } }
    function num(x, d) {
        try { return x.toLocaleString(intl(), { minimumFractionDigits: d, maximumFractionDigits: d }); }
        catch (_) { return x.toFixed(d); }
    }
    function pct(p) { return p >= 10 ? num(Math.round(p), 0) : num(p, 1); }
    function fill(s, map) { return String(s || '').replace(/:([a-z]+)/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
    /* «1 ч 5 мин» по правилам языка (Intl unit, короткая форма): строки тула
       'hours' / 'minutes' — запасной путь для движка без unit-форматирования. */
    function unit(n, u) {
        try { return new Intl.NumberFormat(intl(), { style: 'unit', unit: u, unitDisplay: 'short' }).format(n); }
        catch (_) { return n + ' ' + (u === 'hour' ? (T.hours || 'h') : u === 'minute' ? (T.minutes || 'min') : (T.seconds || 's')); }
    }
    function fmtHours(h) {
        if (h === Infinity) return D.left_unlimited;
        if (!(h > 0)) return D.left_none;
        var secs = Math.round(h * 3600);
        if (secs < 60) return unit(Math.max(1, secs), 'second');
        var mins = Math.round(secs / 60), hh = Math.floor(mins / 60), mm = mins % 60;
        if (!hh) return unit(mm, 'minute');
        return mm ? unit(hh, 'hour') + ' ' + unit(mm, 'minute') : unit(hh, 'hour');
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function metricLabel(id) { return ND.get(id).metric === 'lex' ? 'LEX,8h' : 'TWA'; }
    /* Норматив с doseMarks (Бразилия, NR-09: «половина дозы») подписывает уровень
       действия процентом дозы: уровень «80 дБ(A)» при пороге NR-15 85 доза не видит. */
    function kindText(mark) {
        if (!mark) return '';
        var s = ND.get(std());
        if (s.doseMarks && mark.kind === 'action' && D.kind_action_dose) {
            return fill(D.kind_action_dose, { pct: Math.round(ND.doseAtMark(std(), mark.level)) });
        }
        return fill(D['kind_' + mark.kind], { db: mark.level });
    }
    function stdName(id) { return (D.std && D.std[id]) || id; }
    function shortName(id) { return (D.std_short && D.std_short[id]) || id; }
    function hoursLabel() { var h = shiftHours(); return num(h, h % 1 ? 1 : 0); }

    /* ── Живой замер ─────────────────────────────────────────────────────── */
    function tick(statsA) {
        if (!statsA) return 0;
        var dE = statsA.leqSum - lastSum, dt = statsA.leqCount - lastCount;
        lastSum = statsA.leqSum; lastCount = statsA.leqCount;
        if (dt > 0 && dE > 0) {
            var L = 10 * Math.log10(dE / dt);
            live.add(L, dt);
            recent.push({ e: dE, t: dt });
            if (recent.length > 10) recent.shift();
        }
        render();
        return live.dose(std());
    }
    function reset() { live.reset(); lastSum = 0; lastCount = 0; recent = []; render(); }
    function currentLevel() {
        var e = 0, t = 0;
        for (var i = 0; i < recent.length; i++) { e += recent[i].e; t += recent[i].t; }
        return t > 0 ? 10 * Math.log10(e / t) : -Infinity;
    }

    function state() { try { return SM.state ? SM.state() : null; } catch (_) { return null; } }

    function peakText() {
        var st = state();
        if (!st || !st.stats || !st.stats.c) return '—';
        var pk = st.stats.c.peak, ceil = Math.round(st.offset || 120);
        if (st.clipping || (isFinite(pk) && pk >= ceil - 0.5)) return fill(D.peak_clipped, { db: ceil });
        return isFinite(pk) && pk > 0 ? num(pk, 1) + ' dB(C)' : '—';
    }

    function projection(id) {
        var secs = live.seconds();
        if (secs < 30) return null;
        var dose = live.dose(id);
        var proj = dose * shiftHours() / (secs / 3600);
        return { dose: dose, proj: proj, value: ND.eightHour(id, proj) };
    }

    function setText(id, s) { var el = $(id); if (el && el.textContent !== s) el.textContent = s; }

    function render() {
        if (!card) return;
        var id = std(), secs = live.seconds();
        setText('smDzTime', secs >= 1 ? fmtHours(secs / 3600) : '—');
        var leq = live.leq();
        setText('smDzLeq', isFinite(leq) ? num(leq, 1) + ' dBA' : '—');
        setText('smDzDose', secs >= 1 ? pct(live.dose(id)) + '%' : '—');
        setText('smDzMetric', fill(D.t_shift, { h: hoursLabel() }));
        setText('smDzPeak', peakText());

        var p = projection(id), badge = $('smDzBadge'), line = $('smDzLine');
        if (!p) {
            setText('smDz8', '—');
            setText('smDzLeft', '—');
            if (badge) { badge.className = 'sm-dz-badge'; badge.textContent = ''; badge.hidden = true; }
            if (line) line.textContent = secs > 0 ? D.wait : D.idle;
            return;
        }
        var v = p.value, mark = isFinite(v) ? ND.verdict(id, v) : null;
        setText('smDz8', isFinite(v) ? metricLabel(id) + ' ' + num(v, 1) : '—');
        setText('smDzLeft', fmtHours(ND.remainingHours(id, p.dose, currentLevel())));
        if (badge) {
            var kind = !mark ? 'ok' : mark.kind === 'limit' ? 'limit' : 'action';
            badge.className = 'sm-dz-badge sm-dz-' + kind;
            badge.textContent = D['badge_' + kind];
            badge.hidden = false;
        }
        if (line) {
            line.textContent = fill(mark ? D.line_hit : D.line_under, {
                h: hoursLabel(), metric: metricLabel(id), value: isFinite(v) ? num(v, 1) : '—', mark: kindText(mark)
            });
        }
    }

    /* ── Норматив: подпись, источник, плитка 8 ч ───────────────────────────── */
    function applyStandard() {
        var id = std(), s = ND.get(id);
        setText('smDzSrc', (D.src_prefix || '') + ' ' + s.src);
        setText('smDzMarks', (D.marks_prefix ? D.marks_prefix + ' ' : '') + s.marks.map(function (m) { return kindText({ level: m[0], kind: m[1] }); }).join(' · '));
        var elv = $('smDzElv');
        if (elv) elv.hidden = id !== 'eu';
        var peaks = s.peaks.map(function (pk) { return pk[0]; });
        setText('smDzPeakNote', peaks.length ? fill(D.peak_note, { list: peaks.join(' / ') }) : D.peak_note_none);
        var twa = $('smTwa');
        var lab = twa && twa.previousElementSibling;
        if (lab) { lab.textContent = metricLabel(id); lab.setAttribute('title', fill(D.metric_hint, { std: shortName(id) })); }
        try { if (SM.refresh) SM.refresh(); } catch (_) {}
        render();
        renderTasks();
    }

    /* ── Калькулятор задач смены ──────────────────────────────────────────── */
    var rowsEl = $('smTaskRows');
    function saveTasks() {
        try { window.__toolSettings && window.__toolSettings.save(SLUG, 'dose_tasks', tasks); } catch (_) {}
    }
    function addTask(t) {
        tasks.push({ name: t.name || fill(D.task_default, { n: tasks.length + 1 }), level: t.level, h: t.h || 0, m: t.m || 0 });
        saveTasks(); renderTasks();
    }
    function taskHours(t) { return Math.max(0, (parseFloat(t.h) || 0) + (parseFloat(t.m) || 0) / 60); }
    function taskRow(t, i) {
        var tr = document.createElement('div');
        tr.className = 'sm-task';
        tr.innerHTML =
            '<input class="sm-task-name" type="text" maxlength="60" aria-label="' + esc(D.task_name) + '" value="' + esc(t.name) + '">' +
            '<label class="sm-task-f"><input class="sm-task-level" type="number" inputmode="decimal" min="40" max="140" step="0.1" aria-label="' + esc(D.task_level) + '" value="' + (isFinite(t.level) ? t.level : '') + '"><span>dBA</span></label>' +
            '<label class="sm-task-f"><input class="sm-task-h" type="number" inputmode="numeric" min="0" max="24" step="1" aria-label="' + esc(D.task_hours) + '" value="' + (t.h || 0) + '"><span>' + esc(T.hours || 'h') + '</span></label>' +
            '<label class="sm-task-f"><input class="sm-task-m" type="number" inputmode="numeric" min="0" max="59" step="5" aria-label="' + esc(D.task_minutes) + '" value="' + (t.m || 0) + '"><span>' + esc(T.minutes || 'min') + '</span></label>' +
            '<button type="button" class="sm-task-del" aria-label="' + esc(D.task_remove) + '">&times;</button>' +
            '<span class="sm-task-out"></span>';
        function upd() {
            t.name = tr.querySelector('.sm-task-name').value;
            t.level = parseFloat(tr.querySelector('.sm-task-level').value);
            t.h = Math.max(0, Math.min(24, parseInt(tr.querySelector('.sm-task-h').value, 10) || 0));
            t.m = Math.max(0, Math.min(59, parseInt(tr.querySelector('.sm-task-m').value, 10) || 0));
            saveTasks(); renderTotals();
        }
        tr.addEventListener('input', upd);
        tr.querySelector('.sm-task-del').addEventListener('click', function () {
            tasks.splice(i, 1); saveTasks(); renderTasks();
        });
        return tr;
    }
    function renderTasks() {
        if (!rowsEl) return;
        rowsEl.textContent = '';
        tasks.forEach(function (t, i) { rowsEl.appendChild(taskRow(t, i)); });
        var empty = $('smTaskEmpty');
        if (empty) empty.hidden = tasks.length > 0;
        renderTotals();
    }
    function taskSummary(id) {
        var segs = tasks.filter(function (t) { return isFinite(t.level) && taskHours(t) > 0; })
            .map(function (t) { return { level: t.level, hours: taskHours(t) }; });
        var dose = ND.doseOf(id, segs), value = ND.eightHour(id, dose);
        return { segs: segs, dose: dose, value: value, mark: dose > 0 ? ND.verdict(id, value) : null,
                 hours: segs.reduce(function (a, x) { return a + x.hours; }, 0) };
    }
    function totalText(id, s) {
        return fill(D.total_line, { metric: metricLabel(id), value: isFinite(s.value) ? num(s.value, 1) : '—', percent: pct(s.dose), time: fmtHours(s.hours) });
    }
    function renderTotals() {
        var id = std();
        if (rowsEl) {
            var outs = rowsEl.querySelectorAll('.sm-task-out');
            tasks.forEach(function (t, i) {
                var o = outs[i]; if (!o) return;
                if (!isFinite(t.level)) { o.textContent = ''; return; }
                var pd = ND.partialDose(id, t.level, taskHours(t));
                o.textContent = fill(D.task_share, { percent: pct(pd) }) + ' · ' + fill(D.task_allowed, { time: fmtHours(ND.allowedHours(id, t.level)) });
            });
        }
        var tot = $('smTaskTotal');
        if (!tot) return;
        var s = taskSummary(id);
        if (!s.segs.length) { tot.textContent = ''; tot.hidden = true; return; }
        tot.hidden = false;
        var txt = totalText(id, s);
        if (ND.get(id).points) txt += ' · ' + fill(D.points, { n: Math.round(s.dose) });
        txt += ' — ' + (s.mark ? kindText(s.mark) : D.badge_ok);
        tot.textContent = txt;
        tot.className = 'sm-task-total sm-dz-' + (!s.mark ? 'ok' : s.mark.kind === 'limit' ? 'limit' : 'action');
    }

    /* ── Отчёты ──────────────────────────────────────────────────────────── */
    function pdfHtml() {
        var id = std(), out = [];
        out.push('<b>' + esc(D.pdf_std) + ':</b> ' + esc(stdName(id)));
        var secs = live.seconds();
        if (secs >= 1) {
            out.push(esc(D.t_dose) + ': ' + pct(live.dose(id)) + '% · LAeq ' + (isFinite(live.leq()) ? num(live.leq(), 1) : '—') + ' dBA · ' + esc(fmtHours(secs / 3600)));
        }
        var p = projection(id);
        if (p) {
            var mark = isFinite(p.value) ? ND.verdict(id, p.value) : null;
            out.push(esc(fill(mark ? D.line_hit : D.line_under, { h: hoursLabel(), metric: metricLabel(id), value: isFinite(p.value) ? num(p.value, 1) : '—', mark: kindText(mark) })));
        }
        var s = taskSummary(id);
        if (s.segs.length) {
            out.push('<b>' + esc(D.pdf_tasks) + ':</b>');
            tasks.forEach(function (t) {
                if (!isFinite(t.level) || !(taskHours(t) > 0)) return;
                out.push('· ' + esc(t.name) + ' — ' + num(t.level, 1) + ' dBA × ' + esc(fmtHours(taskHours(t))) + ' → ' + pct(ND.partialDose(id, t.level, taskHours(t))) + '%');
            });
            out.push(esc(totalText(id, s)));
        }
        out.push(esc(D.pdf_note));
        return out.join('<br>');
    }
    function csv() {
        var id = std(), rows = [];
        rows.push('Standard,' + id);
        rows.push('Shift (h),' + shiftHours());
        var p = projection(id);
        if (p) rows.push(metricLabel(id) + ' if the whole shift is like this (dBA),' + (isFinite(p.value) ? p.value.toFixed(1) : ''));
        var s = taskSummary(id);
        if (s.segs.length) {
            rows.push('Task,Level dBA,Hours,Dose %');
            tasks.forEach(function (t) {
                if (!isFinite(t.level) || !(taskHours(t) > 0)) return;
                rows.push('"' + String(t.name).replace(/"/g, '""') + '",' + t.level + ',' + taskHours(t).toFixed(2) + ',' + ND.partialDose(id, t.level, taskHours(t)).toFixed(1));
            });
            rows.push('Shift total ' + metricLabel(id) + ' (dBA),' + (isFinite(s.value) ? s.value.toFixed(1) : '') + ',,' + s.dose.toFixed(1));
        }
        return rows.join('\n') + '\n';
    }

    /* ── Подключение ─────────────────────────────────────────────────────── */
    function wire() {
        var ts = window.__toolSettings;
        if (ts) {
            ts.bind(SLUG, stdSel, 'dose_std', ND.defaultFor(locale));
            ts.bind(SLUG, shiftIn, 'dose_shift', 8);
            var saved = ts.load(SLUG, 'dose_tasks', null);
            if (Array.isArray(saved)) tasks = saved.filter(function (t) { return t && typeof t === 'object'; }).slice(0, 30);
        }
        if (stdSel && !ND.STANDARDS[stdSel.value]) stdSel.value = ND.defaultFor(locale);
        if (stdSel) stdSel.addEventListener('change', applyStandard);
        if (shiftIn) shiftIn.addEventListener('input', render);
        var add = $('smTaskAdd'), addM = $('smTaskAddMeasured');
        if (add) add.addEventListener('click', function () { addTask({ level: NaN, h: 1, m: 0 }); });
        if (addM) addM.addEventListener('click', function () {
            var secs = live.seconds(), leq = live.leq();
            if (!(secs >= 1) || !isFinite(leq)) { if (window.__toast) window.__toast(D.task_need_measure, 'info'); return; }
            var mins = Math.max(1, Math.round(secs / 60)), at = '';
            try { at = new Date().toLocaleTimeString(intl(), { hour: '2-digit', minute: '2-digit' }); } catch (_) {}
            addTask({ name: fill(D.task_measured_name, { time: at }), level: Math.round(leq * 10) / 10, h: Math.floor(mins / 60), m: mins % 60 });
        });
        applyStandard();
    }

    window.SMDose = {
        tick: tick,
        reset: reset,
        allowedSeconds: function (L) { var h = ND.allowedHours(std(), L); return h === Infinity ? Infinity : h * 3600; },
        doseText: function (dose, lastDb) {
            var s = ND.get(std());
            var floor = s.threshold != null ? s.threshold : s.marks[0][0];
            if (dose < 0.1 && !(lastDb >= floor)) return fill(D.dose_safe, { db: floor });
            return fill(T.dose_of_daily, { percent: pct(dose), std: shortName(std()) });
        },
        eightHourText: function (weight) {
            if (weight && weight !== 'a') return null;
            if (!(live.seconds() >= 1)) return null;
            var v = ND.eightHour(std(), live.dose(std()));
            return isFinite(v) ? v.toFixed(1) : '—';
        },
        eightLabel: function () { return metricLabel(std()); },
        pdfHtml: pdfHtml,
        csv: csv
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
    else wire();
})();
